module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_5012.3263cbbd.png";